<template>
  <div>
    <template v-if="loading_step === false">
      <div class="row uploads-wrapper">
        <ul class="col s12 no-padding collapsible clearfix uploads">
          <li v-for="(hash, key) in hashes" v-bind:key="key" class="col s12 no-padding">
            <div class="collapsible-header">
              {{ hashes[key].title }}
              <i v-if="verificaDoc(key) === true" class="material-icons">check</i>
            </div>
            <div class="col s12 no-padding collapsible-body">
              <div class="file-field input-field">
                <div class="col s12 no-padding">
                  <div v-show="uploadInProgress[key] === true" class="loading-wrapper">
                    <loading-upload />
                  </div>
                  <div v-show="uploadInProgress[key] !== true ">
                    <div v-if="key !== 'hash_dep'" class="btn-wrapper">
                      <i class="material-icons">photo_camera</i>
                      <file-storage-upload
                        @startUpload="handleStartUpload(key)" @finishedUpload="handleFinishedUpload" @failedUpload="handleFailedUpload"
                        v-bind:ref_id="pf_id" accept="image/*,.pdf" styleStr="max-height: 64px;"
                      />
                    </div>
                    <p class="dica-digitalizacao" v-html="`Dica: ${hashes[key].info}`"></p>
                    <p v-if="key === 'hash_dep'" class="dica-digitalizacao">
                      Você deve digitalizar separadamente um ou mais documentos que contenham a Identidade(RG, CNH ou Certidão de Nascimento) e o CPF de cada um dos seguintes dependentes: 
                    </p>
                  </div>
                </div>

                <div v-show="uploadInProgress[key] !== true" class="col s11 m9">

                  <ul v-if="key === 'wa9tia'" class="thumbs-wrapper">
                    <p class="col s12 title-thumbs-wrapper">Imagens enviadas:</p>
                    <template v-for="(foto, i) in fotos">
                      <li v-bind:key="i">
                        <img class="materialboxed" v-bind:data-caption="`${hashes[key].title} ${i}`" :src="`${url_storage}/${foto['file_id']}?q=100`" />
                        <a @click="removeImagem(foto['file_id'], key)" class="delete-btn-wrapper">
                          <i class="material-icons delete-button">clear</i>
                        </a>
                      </li>
                    </template>
                  </ul>

                  <div v-else-if="key === 'hash_dep'" > <!-- Tela de dependentes -->
                      <template v-for="(dep, index) in servidor_info.dependentes">
                        <div v-bind:key="index">
                          <div class="col s12 m9 dependente-container" v-bind:key="index">
                            <a  class="waves-effect waves-light btn dica-digitalizacao" @click="openModalDepUpload(dep.pf_id)">
                              <i class="material-icons left">photo_camera</i>
                              <span>
                                {{ dep.nome.split(" ").shift() }} {{ dep.nome.split(" ").pop() }} 
                                <!-- <font class="hide-on-small-only"> -->
                                - {{ rel_familiar[dep.parentesco] }}
                                <!-- </font> -->
                              </span> 
                            </a>
                            <br />
                          </div>
                          <div class="col s12 ">
                            <ul class="thumbs-wrapper">
                              <template v-if="dependenteDoc.find(ele => ele.pf_id === dep.pf_id)">
                                <template v-for="(foto, ind) in dependenteDoc.find(ele => ele.pf_id === dep.pf_id).documentos">
                                  <li v-bind:key="ind">
                                    <img class="materialboxed doc-dependente" :src="foto.url" />
                                    <a @click="removeImagem(foto['file_id'], 'all')" class="delete-btn-wrapper">
                                      <i class="material-icons delete-button">clear</i>
                                    </a>
                                  </li>
                                </template>
                              </template>
                            </ul>  
                          </div>
                        </div>
                      </template>
                    </div>

                  <ul v-else class="thumbs-wrapper">
                    <p class="col s12 title-thumbs-wrapper">Imagens enviadas:</p>
                    <template v-for="(doc_info, i) in docs[key]">
                      <li v-bind:key="i">
                        <img class="materialboxed" v-bind:data-caption="`${hashes[key].title} ${(i +1)}`" v-bind:src="`${url_storage}/${doc_info['file_id']}?q=100`" />
                        <a @click="removeImagem(doc_info['file_id'], key)" class="delete-btn-wrapper">
                          <i class="material-icons delete-button">clear</i>
                        </a>
                      </li>
                    </template>
                  </ul>

                </div>

              </div>
            </div>
            <div id="addImage" class="modal modalUpload">
              <div class="modal-header">
                <a @click.prevent class="modal-close">
                  <i class="material-icons right">close</i>
                </a>
                <h5 class="">Capturar imagem</h5>
              </div>
              <div class="modal-content">
                <div class="input-field">
                  <select v-model="selected_type_dep" id="sel_doc" >
                    <option value selected>Selecionar Documento</option>
                    <option v-for="(doc_type, i) in meta.docs_dependentes" v-bind:key="i" v-bind:value="i">{{ doc_type }}</option>
                  </select>
                  <label for="sel_doc" >Selecionar Documento</label>
                </div>
                <div v-if="selected_type_dep !== null" class="file-field input-field">
                  <div v-if="uploadInProgress === true" class="loading-wrapper">
                    <loading />
                  </div>
                  <div v-else class="btn-wrapper center teste">
                    <i class="material-icons large">photo_camera</i><br>
                  
                    <file-storage-upload 
                      @startUpload="handleStartUploadDep('hash_dep')" @finishedUpload="handleFinishedUploadDep" @failedUpload="handleFailedUpload"
                      v-bind:ref_id="pf_id_dep" accept="image/*,.pdf" styleStr="max-height: 64px;"
                    />
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="step-actions row col s12">
        <button type="button" class="waves-effect waves-dark btn-flat previous-step col s6 left no-padding">Anterior</button>
        <button v-if="step_incomplete >= 0 && step_incomplete < 5" @click="goTo(step_incomplete)" type="button" class="waves-effect waves-dark btn col s6 right">REVISAR INCONSISTÊNCIAS</button>
        <button v-else type="button" class="waves-effect waves-dark btn col s6 right modal-trigger" href="#modal-confirm">CONCLUIR</button>
      </div>
    </template>
    <template v-else>
      <loading-upload />
    </template>

    <div id="modal-confirm" class="modal">
      <div class="modal-content" v-html="meta.general_texts.modal_steps_done"></div>
      <div class="modal-footer">
        <a class="modal-close waves-effect red lighten-2 white-text waves-light btn-flat">Cancelar</a>
        <a @click="finalizarCadastro" class=" waves-effect teal lighten-2 white-text waves-light btn-flat">Concluir</a>
      </div>
    </div>
  </div>
</template>
<script>
  import FileStorageUpload from '@/components/FileStorageUpload.vue'
  import Loading from '@/components/Loading.vue'
  import axios from 'axios'
  import { CONFIG } from '@/config/config.js'
  let uuid_service = require("uuid")

let device_info = {
  'id': uuid_service.v4().substr(0, 30),
  'log': {
    'lat': -7.98391133, //BRA HeadQuarter's location
    'lon': -34.83876744
  }    
}

  export default {
    name: 'Upload',
    components: {
      'file-storage-upload': FileStorageUpload,
      'loading-upload': Loading
    },
    props: {
      document_info: Object,
      servidor_info: Object,
      perfil_data: Object,
      step_incomplete: Number,
    },
    data (){
      return {
        meta: this.$store.state.meta.data,
        rel_familiar: this.$store.state.meta.data.rel_familiar_simples,
        uploadInProgress: {},
        pf_id: this.$store.state.user.pfId,
        pf_id_dep: null,
        // pf_id_dep_num: [],
        dependenteDoc: [],
        oid: this.$store.state.user.oid,
        nome: this.$store.state.user.nome,
        docs_info: this.document_info,
        selected_type: null,
        selected_type_dep: null,
        step_completed: false,
        loading_step: true,
        selectedMunicipio: localStorage.selectedMunicipio,
        url_storage: CONFIG.URL_ARQUIVOS,
        hashes2names: {}, //Obrigatórios sempre 
        hashes2namesReq: { //Obrigatórios em certas condicionais
        },
        hashes2NamesCat: {},
        hashes2namesOpt: {},
        collapsible: null,
      }
    },
    computed: {
      fotos (){
        let fotos_p = this.document_info.wa9tia.public
        let fotos_pr = this.document_info.wa9tia.private

        if(fotos_p.length > 0){
          return fotos_p
        }

        if(fotos_pr.length > 0){
          return fotos_pr
        }
        return []
      },
      hashes: function () {
        return {...this.hashes2names, ...this.hashes2namesReq, ...this.hashes2namesOpt}
      },
      docs (){
        let docs = {}
        Object.keys(this.docs_info).filter(k => k !== 'wa9tia').forEach((hash) => docs[hash] = this.docs_info[hash])
        return docs
      },
      verifica: function () {
        try {
          if(this.docs_info.wa9tia.private.length < 1){
            status = false
          }

          let keys = Object.keys(this.getRequiredDocs())

          let status = true //Até que se prove o contrário
          keys.forEach((key) => {
            if(key == 'hash_dep'){
              status = this.verificaDoc('hash_dep')
            } else {
              status = this.docs_info[key].length > 0
            }
          })

          return status 
        } catch (error) {
          return error
        }
      },
    },
    methods: {
      getDocumentosDependentes(pf_id){ // Requisição dos documentos dos dependentes FAZER CATCH
        axios.get(`${CONFIG.URL_STORAGE_API}/v2/docs/${pf_id}/`)
          .then(({ data: { data: { StorageAPI: { files } } } }) => {
            const filesFiltered = files.filter(file => file.author.uupfid === this.pf_id)
            
            this.dependenteDoc.push({
              pf_id: pf_id,
              documentos: filesFiltered
            })
          }).catch((error) => {
        })
      },
      getPFIDDependentes(){ // Mapeia os dependentes fazendo uma requisição para cada.
        this.servidor_info.dependentes.map((dependente) => {
          this.getDocumentosDependentes(dependente.pf_id)
        })
      },
      openModalDepUpload(pf_id_dep){ // Abre o modal de upload
        this.pf_id_dep = pf_id_dep
        M.Modal.getInstance(document.querySelector('.modalUpload')).open()
      },
      verificaStatusPasso(){
        try {
          let status = true //Até que se prove o contrário

          if(this.docs_info.wa9tia.private.length < 1 && this.docs_info.wa9tia.public.length < 1){
            this.step_completed = false
            return false
          }

          let keys = Object.keys(this.getRequiredDocs())
          let atual = this.hashes

          for(let key of keys) {
            if(key === 'wa9tia') continue //Foto do Perfil já verificada

            //CTC, CTPS, CNIS se complementam, apenas 1 dos 3 é orbigatório e somente para ativos
            if(['eoaedt', 'ydog05'].includes(key) && (this.servidor_info.categoria_cods.includes(1))){
              //Se os 3 estiverem vazios, o alerta deve ser exibidos em todos
              if(this.docs_info['eoaedt'].length === 0 && this.docs_info['ydog05'].length === 0){
                status = false
                break
              }
            } else if (key === 'hash_dep'){ // Verificação especial dos dependentes
              status = this.verificaDoc('hash_dep')
            } else if (Object.keys(this.hashes2NamesCat).includes(key)){ // Verificação especial dos Atos/Portarias de Posse
              status = this.verificaDoc(key)
            } else if(key === 'b2j5qi'){ // Título de Eleitor
              status = this.verificaDoc(key)
            } else if(key === 'tdlt8z'){ // Reservista
              status = this.verificaDoc(key)
            } else { // Demais verificações
              status = (key in this.docs_info && this.docs_info[key].length >= atual[key].count ? true : false)
            }

            // Se a verificação de alguma key falhou
            if(status === false) {
              this.step_completed = status
              return false
            }
          }

          this.step_completed = status
          return status
        } catch (e) {
          console.error(e)
          this.step_completed = false
          return false
        }
      },
      verificaDoc(hash){
        let reqs = this.getRequiredDocs()
        let atual = this.hashes

        if(hash === 'wa9tia'){
          return this.docs_info.wa9tia.private.length >= atual.wa9tia.count
        }

        // Portaria de Posse
        if(['ebdf70'].includes(hash)){

          if(this.hashes2NamesCat['ebdf70'].filter(cat => this.servidor_info.categoria_cods.includes(cat)).length === 0){
            return (this.docs_info['ebdf70'].length > 0 ? true : null)
          }

          if(this.docs_info['ebdf70'].length < this.servidor_info.categoria_cods.filter(c => c <= 3).length) {
            return false
          } else {
            return true
          }
        }

        // Portaria de Concessão de Benefício
        if(['d06f17'].includes(hash)){

          if(this.hashes2NamesCat['d06f17'].filter(cat => this.servidor_info.categoria_cods.includes(cat)).length === 0){
            return (this.docs_info['d06f17'].length > 0 ? true : null)
          }

          if(this.docs_info['d06f17'].length < reqs['d06f17'].count) {
            return false
          } else {
            return true
          }
        }

        if(hash === 'b2j5qi'){ // Título de Eleitor
          if('b2j5qi' in this.hashes2names) {
            if(this.perfil_data.idade >= 18){
              return (this.docs_info['b2j5qi'].length > 0 ? true : false)
            } else {
              return (this.docs_info['b2j5qi'].length > 0 ? true : null) // Opcional para menores de 18 anos
            }
          }
        }

        if(hash === 'tdlt8z'){ // Reservista
          if('tdlt8z' in this.hashes2names) {
            if(this.perfil_data.sexo === "M" && this.perfil_data.idade >= 18 && this.servidor_info.categoria_cods.includes(1)){
              return (this.docs_info['tdlt8z'].length > 0 ? true : false)
            } else {
              return (this.docs_info['tdlt8z'].length > 0 ? true : null) //Dispensado para mulheres ou menores de 18 anos
            }
          }
        }

        if(['btvl1j'].includes(hash)){
          if(this.docs_info['btvl1j'].length === 0) {
            return false
          } else {
            return true
          }
        }

        if(['hash_dep'].includes(hash)){
          let dep_com_docs = (new Set(this.dependenteDoc.map(dep => dep['pf_id']))).size

          if(dep_com_docs === 0 || (this.servidor_info.dependentes && this.servidor_info.dependentes.length > dep_com_docs)) {
            return false
          } else {
            return true
          }
        }

        if(Object.keys(reqs).includes(hash)){
          //CTC, CTPS, CNIS se complementam, apenas 1 dos 3 é orbigatório
          if(['eoaedt', 'ydog05'].includes(hash)){
            //Se os 3 estiverem vazios, o alerta será exibido apenas em CTPS/CNIS, caso se trate de um servidor ativo ou inativo
            if(this.docs_info['eoaedt'].length === 0 && this.docs_info['ydog05'].length === 0 && this.servidor_info.categoria_cods.includes(1) && hash === 'ydog05'){
              return false
            } else {
              return (hash in this.docs_info && this.docs_info[hash].length > 0 ? true : null) // Exibe o sinal de OK para os que foram enviados e não exibe nada quando estão vazios
            }
          } else {
            return (hash in this.document_info && this.docs_info[hash].length >= atual[hash].count ? true : false)
          }
        } else {
          return (hash in this.docs_info && this.docs_info[hash].length > 0 ? true : null) //Não exibir alerta de erro se não for obrigatório e estiver vazio
        }
      },
      getRequiredDocs(){
        return {...this.hashes2names, ...this.hashes2namesReq}
      },
      finalizarCadastro() {
        this.loading_step = true
        axios.post(`${CONFIG.URL_RECAD_API_V2}/v1/higienize-segurado/`, {
          pf_id: this.pf_id,
          status: 'locked'
        })
        .then(() => {
          delete localStorage['reviewd']
          this.$router.push('/Status/')
        })
        .catch(() => {
          this.loading_step = false
          M.toast({html: 'Ops! Não foi possível atender a esta solicitação neste momento...Tente novamente em instantes.'})
        })
      },
      goTo(step) {
        this.$emit('goToStep', step)
      },
      handleStartUpload(hash){
        this.selected_type = hash
        this.$set(this.uploadInProgress, this.selected_type, true)
      },
      handleStartUploadDep(hash){
        this.selected_type = hash
        this.$set(this.uploadInProgress, this.selected_type, true)
        M.Modal.getInstance(document.querySelector('.modalUpload')).close()
      },
      handleFinishedUpload(data){
        let file_data = {
          document_id: this.meta.hashes2docs[this.selected_type],
          file_obj: data[0]
        }

        let hash = this.selected_type

        if(this.selected_type === 'wa9tia'){
          this.addDocFoto(file_data['file_obj'], hash)
        } else if(['i0k6d5', 'er0zqc', 'ebdf70', 'd06f17'].includes(this.selected_type)) {
          this.addDocRecad(file_data['file_obj'], hash, this.pf_id)
        } else {
          this.addDoc(file_data['file_obj'], hash, this.pf_id)
        }
      },
      handleFinishedUploadDep(data){
        let file_data = {
          document_id: this.meta.hashes2docs[this.selected_type_dep],
          file_obj: data[0]
        }

        let hash = this.selected_type_dep

        if(['i0k6d5', 'er0zqc', 'ebdf70', 'd06f17'].includes(this.selected_type_dep)) {
          this.addDocRecad(file_data['file_obj'], hash, this.pf_id_dep, 'Dependente')
        } else {
          this.addDoc(file_data['file_obj'], hash, this.pf_id_dep, 'Dependente')
        }
      },
      handleFailedUpload(data){
        this.uploadInProgress[this.selected_type] = false
        this.$root.$emit('stopLoadingHeader')
        if(data.hasOwnProperty('error')){
          M.toast({html: data.error})
        } else {
          M.toast({html: 'Ops! Não foi possível fazer o upload do arquivo neste momento...Tente novamente em instantes.'})
        }
      },
      addDoc(doc, hash, pf_id, dep){
        axios.put(`${CONFIG.URL_SOCIAL_API_V2}/v1/pessoa-fisica/document/change/`, {
          "pf_id": pf_id,
          "file_id": doc['file_id'],
          "add": [
            hash
          ],
          "remove": [
          ],
          "device": device_info
        })
        .then((respnse) => {
          if(dep === undefined) {
            this.addItemToDocs(this.selected_type, doc['file_id'])
          } else {
            this.addItemTodependenteDoc(doc, hash, pf_id)
            
          }
          this.uploadInProgress[this.selected_type] = false
        })
        .catch((error) => {
          if(error.response !== 404){
            M.toast({html: "Ops! Não foi possível realizar esta XXXXXoperação...tente novamente em instantes."})
          }
        })
        .finally(() => {
          this.$root.$emit('stopLoadingHeader')
          M.Materialbox.init(document.querySelectorAll('.materialboxed'))
        })
      },
      addDocRecad(doc, hash, pf_id, dep){
        axios.put(`${CONFIG.URL_RECAD_API_V2}/v1/servidor/document/change/`, {
          "pf_id": pf_id,
          "file_id": doc['file_id'],
          "add": [
            hash
          ],
          "remove": [
          ],
          "device": device_info
        })
        .then((respnse) => {
          if(dep === undefined) {
            this.addItemToDocs(this.selected_type, doc['file_id'])
          } else {
            this.addItemTodependenteDoc(doc, hash, pf_id)
          }
          this.uploadInProgress[this.selected_type] = false
        })
        .catch((error) => {
          if(typeof error === 'object' && 'response' in error && error.response !== 404){
            M.toast({html: "Ops! Não foi possível realizar esta operação...tente novamente em instantes."})
          }
        })
        .finally(() => {
          this.$root.$emit('stopLoadingHeader')
          M.Materialbox.init(document.querySelectorAll('.materialboxed'))
        })
      },
      addDocFoto(doc, hash){
        axios.post(`${CONFIG.URL_SOCIAL_API_V2}/v1/pessoa-fisica/foto/`, {
          "pf_id": this.pf_id,
          "file_id": doc['file_id'],
          "device": device_info
        })
        .then((respnse) => {
          this.addItemToDocs(hash, doc['file_id'])
          this.uploadInProgress[hash] = false
          M.toast({html: "Imagem enviada com sucesso!"})
        })
        .catch((error) => {
          if(error.response !== 404){
            M.toast({html: "Ops! Não foi possível realizar esta operação...tente novamente em instantes."})
          }
        })
        .finally(() => {
          this.$root.$emit('stopLoadingHeader')
          M.Materialbox.init(document.querySelectorAll('.materialboxed'))
        })
      },
      removeImagem(file_id, hash) {
        this.$set(this.uploadInProgress, hash, true)
        if(hash !== 'all') {
          if(hash === 'wa9tia'){
            this.removeDocFoto(file_id, hash)
          } else if(['i0k6d5', 'er0zqc', 'ebdf70', 'd06f17'].includes(hash)) {
            this.removeDocRecad(file_id, hash)
          } else {
            this.removeDoc(file_id, hash)
          }
        } else {
          this.removeDocRecad(file_id, hash)
          this.removeDoc(file_id, hash)
        }
      },
      removeDoc(file_id, hash){
        axios.put(`${CONFIG.URL_SOCIAL_API_V2}/v1/pessoa-fisica/document/change/`, {
          "pf_id": this.pf_id,
          "file_id": file_id,
          "add": [],
          "remove": [
            hash
          ],
          "device": device_info
        })
        .then((respnse) => {
          this.deleteStorageFile(file_id)
          this.removeItemFromDocs(hash, file_id)
        })
        .catch((error) => {
          if(error.response !== 404 && hash !== 'all'){
            M.toast({html: "Ops! Não foi possível realizar esta operação...tente novamente em instantes."})
          }
        })
        .finally(() => {
          this.uploadInProgress[hash] = false
          M.Materialbox.init(document.querySelectorAll('.materialboxed'))
        })
      },
      removeDocRecad(file_id, hash){
        
        axios.put(`${CONFIG.URL_RECAD_API_V2}/v1/servidor/document/change/`, {
          "pf_id": this.pf_id,
          "file_id": file_id,
          "add": [],
          "remove": [
            hash
          ],
          "device": device_info
        })
        .then((respnse) => {
          this.deleteStorageFile(file_id)
          this.removeItemFromDocs(hash, file_id)
        })
        .catch((error) => {
          if(typeof error === 'object' && 'response' in error && error.response !== 404){
            M.toast({html: "Ops! Não foi possível realizar esta operação...tente novamente em instantes."})
          }
        })
        .finally(() => {
          this.uploadInProgress[hash] = false
          M.Materialbox.init(document.querySelectorAll('.materialboxed'))
        })
      },
      removeDocFoto(file_id, hash){
        axios({
          method: "DELETE",
          url:`${CONFIG.URL_SOCIAL_API_V2}/v1/pessoa-fisica/foto/${this.pf_id}/${file_id}/`, 
          data: {
          "device": device_info
          }
        })
        .then((respnse) => {
          this.deleteStorageFile(file_id)
          this.removeItemFromDocs(hash, file_id) 
        })
        .catch((error) => {
          if(error.response !== 404){
            M.toast({html: "Ops! Não foi possível realizar esta operação...tente novamente em instantes."})
          }
        })
        .finally(() => {
          this.uploadInProgress[hash] = false
          M.Materialbox.init(document.querySelectorAll('.materialboxed'))
        })
      },
      addItemTodependenteDoc(doc, hash, pf_id){
        if(this.dependenteDoc.find(ele => ele.pf_id === pf_id)){
          this.dependenteDoc.find(ele => ele.pf_id === pf_id).documentos.push(
            {
              'pf_id': pf_id,
              'file_id': doc.file_id,
              'name': doc.name,
              'url': doc.url
            }
          )
        } else {
          this.dependenteDoc.push(
            {
              'pf_id': pf_id,
              'documentos': {
                0: {
                  'pf_id': pf_id,
                  'file_id': doc.file_id,
                  'name': doc.name,
                  'url': doc.url
                },
              }
            }
          )
        }
      },
      addItemToDocs(hash, file_id){
        let file_obj = {
          'file_id': file_id,
          'author': {
            'oid': this.oid,
            'uupfid': this.pf_id,
            'nome': this.nome,
            'timestamp': '',
          }
        }
        if(hash !== 'wa9tia'){
          this.docs_info[hash].push(file_obj)
        } else {
          file_obj['foto_url'] = null
          this.docs_info[hash].private.push(file_obj)
        }
      },
      removeItemFromDocs(hash, file_id){
        if(hash !== 'wa9tia'){
          if(hash !== 'all') {
            this.docs_info[hash].forEach((doc, i) => {
              if(doc['file_id'] === file_id){
                this.docs_info[hash].splice(i, 1)
              }
            })
          } else {
            this.dependenteDoc.forEach((dep_doc, i) => {
              dep_doc.documentos.forEach((doc, j) => {
                if(doc['file_id'] === file_id){
                  this.dependenteDoc[i].documentos.splice(j, 1)
                }
              })
            })
          }
        } else {
          this.docs_info[hash].private.forEach((foto, i) => {
            if(foto['file_id'] === file_id){
              this.docs_info[hash].private.splice(i, 1)
            }
          })
        }
      },
      deleteStorageFile(file_id){
        axios.delete(`${CONFIG.URL_STORAGE_API}/v2/doc/${file_id}/delete/`)
        .then((response) => {
        })
        .catch((error) => {
          M.toast({html: `Ops! Não foi possível remover esta imagem no momento...tente novamente em instantes.`})
          this.errorDel = true
        })
      },
      updateDocsReq(){
        let reqs = this.hashes2names

        if(this.servidor_info.categoria_cods.includes(3)){
          reqs['b1f25k'] = {
            title: "Certidão de Óbito do Instituidor", 
            count: 1
          }

          //Remove a obrigatoriedade do PIS/PASEP/NIT para pensionistas
          this.hashes2namesOpt = {
            ...{'hg7h0v': {title: "PIS/PASEP/NIT", count: 1, 'info': "Você deve digitalizar um documento que conste o número do PIS, PASEP ou NIT"}}, 
            ...this.hashes2namesOpt
          }
          delete this.hashes2names['hg7h0v']
        }

        if(this.servidor_info.dependentes.length > 0){
          reqs = {
            ...reqs,
            ...{
              'hash_dep': {title: `Dependentes`, count: this.servidor_info.dependentes.length, info: ""},
            }
          }
        }

        // Casado, União Estável, Divorciado
        if(['t5f9wm', 'krcd3f', 'z46swh'].includes(this.servidor_info.est_civil)){
          reqs = {
            ...reqs,
            ...{
              'kilwf3': {title: "Certidão de Casamento", count: 1, 'info': `Digitalize o documento sem cortes <br> A atualização da certidão de casamento pode ser solicitada sem sair de casa através <a target="_blank" href="https://registrocivil.org.br/">deste site</a>.`},
            }
          }
          delete this.hashes2namesOpt['kilwf3']
        } else {
          this.hashes2namesOpt = {
            ...this.hashes2namesOpt,
            ...{
              'kilwf3': {title: "Certidão de Casamento", count: 0, 'info': `Digitalize o documento sem cortes <br> A atualização da certidão de casamento pode ser solicitada sem sair de casa através <a target="_blank" href="https://registrocivil.org.br/">deste site</a>.`},
            }
          }
        }

        if(this.servidor_info.cursos.length > 0){
          let info = "Você deve digitalizar separadamente um documento que comprove que cada uma das formações acadêmicas abaixo: <br />"

          this.servidor_info.cursos.forEach((curso, i) => {
            info += `<strong> - ${curso.curso}(${this.meta.pf_curso_grau[curso.curso_grau]})</strong><br />`
          })

          info += "<br />Caso você não possua este documento no momento, você pode remover retornar ao passo \"2 - DOCUMENTOS\" e remover esta informação para finalizar o processo: <br />"

          reqs = {
            ...reqs,
            ...{
              'cjiy3i': {title: `Comprovante de Escolaridade`, count: this.servidor_info.cursos.length, info: info},
            }
          }
          delete this.hashes2namesOpt['cjiy3i']
        } else {
          this.hashes2namesOpt = {
            ...this.hashes2namesOpt,
            ...{
              'cjiy3i': {title: `Comprovante de Escolaridade`, count: 0, info: "Digitalize o documento sem cortes"},
            }
          }
        }

        // ESTÁVEIS
        if(this.servidor_info.categoria_cods.includes(5)) {
          reqs = {
            ...reqs,
            ...{
              'ebdf70': {title: "Ato de Posse", count: 1, 'info': "Você deve digitalizar um documento para cada vínculo, podendo tirar mais de uma foto, se preciso"},
            }
          }
          delete this.hashes2namesOpt['ebdf70']
        }

        // EFETIVO
        if(this.servidor_info.categoria_cods.includes(1)) {
          reqs = {
            ...reqs,
            ...{
              'ebdf70': {title: "Ato de Posse", count: 1, 'info': "Você deve digitalizar um documento para cada vínculo, podendo tirar mais de uma foto, se preciso"},
            }
          }
          delete this.hashes2namesOpt['ebdf70']
        }

        // INATIVO
        if(this.servidor_info.categoria_cods.includes(2)) {
          reqs = {
            ...reqs,
            ...{
              'ebdf70': {title: "Ato de Posse", count: this.servidor_info.categoria_cods.filter(c => c <= 2).length, 'info': "Você deve digitalizar um documento para cada vínculo, podendo tirar mais de uma foto, se preciso"},
              'd06f17': {title: "Ato de Concessão de Beneficio", count: this.servidor_info.categoria_cods.filter(c => [2, 3].includes(c)).length, 'info': "Você deve digitalizar um documento para cada vínculo, podendo tirar mais de uma foto, se preciso"},

            }
          }
          delete this.hashes2namesOpt['d06f17']
          delete this.hashes2namesOpt['ebdf70']
        }

        // PENSIONISTA
        if(this.servidor_info.categoria_cods.includes(3)) {
          reqs = {
            ...reqs,
            ...{
              'ebdf70': {title: "Ato de Posse do Instituidor", count: 1, 'info': "Você deve digitalizar um documento para cada vínculo, podendo tirar mais de uma foto, se preciso"},
              'd06f17': {title: "Ato de Concessão de Beneficio", count: this.servidor_info.categoria_cods.filter(c => [2, 3].includes(c)).length, 'info': "Você deve digitalizar um documento para cada vínculo, podendo tirar mais de uma foto, se preciso"},

            }
          }
          delete this.hashes2namesOpt['d06f17']
          delete this.hashes2namesOpt['ebdf70']
        }

        if([null, 'null'].includes(this.servidor_info.pne) === false) {
          reqs = {
            ...reqs,
            ...{
              'btvl1j': {title: "Laudo Médico(PCD)", count: 1, 'info': "Você deve digitalizar frente e verso deste documento quando houver, podendo tirar mais de uma foto, se preciso"},
            }
          }
          delete this.hashes2namesOpt['btvl1j']
        }

        this.$set(this, 'hashes2namesReq', reqs)
        this.loading_step = false
        setTimeout(() => this.initStep(), 300)
      },
      initStep() {
        M.Materialbox.init(document.querySelectorAll('.materialboxed'))
        M.Collapsible.init(document.querySelectorAll('.collapsible.uploads'))
        M.Modal.init(document.querySelectorAll('.modal'))
        this.collapsible = M.Collapsible.getInstance(document.querySelectorAll('.collapsible.uploads')[0])
      }
    },
    watch: {
      docs_info: {
        handler: function(updated_docs, old_perfil){
          this.changed = true
          setTimeout(() => {
            this.verificaStatusPasso()
          }, 1000)
        },
        deep: true
      },
      document_info: {
        handler: function(updated_docs, old_perfil){
          setTimeout(() => {
            this.docs_info = this.document_info
          }, 100)
        },
      }
    },
    mounted(){
      this.updateDocsReq()
      this.verificaStatusPasso()
      setTimeout(() => this.getPFIDDependentes(), 1000)
      this.hashes2names = this.meta.censo_domain[this.selectedMunicipio].formulario_documentos_obrigatorios.imagens[0]
      this.hashes2namesOpt = this.meta.censo_domain[this.selectedMunicipio].formulario_documentos_obrigatorios.imagens[1]
      this.hashes2NamesCat = this.meta.censo_domain[this.selectedMunicipio].formulario_documentos_obrigatorios.imagens[2]
    },
    updated() {
      if(this.dependenteDoc.length == 0 && this.servidor_info.dependentes.length > 0){
        this.getPFIDDependentes()
      }
    }
  }
</script>

<style scoped>
  .modal {
    height: 50% !important ;
    border-radius: 10px;
    border-top: 5px #039be5 solid;
  }
  .modal .modal-header {
    border-bottom: 2px #cfcfcf solid;
    padding: 0rem 1.5rem 0px 1.5rem;
  }
  .doc-dependente {
    max-width: 15rem;
    border-radius: 10px;
  }
  .dependente-container {
    padding-top: 1.5rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/steps/Upload.vue